import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { FormattedMessage } from 'react-intl';
import { ADGMModal, ADGMImage } from 'aurora-components';
import Slide from '@material-ui/core/Slide';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core';
import messages from '../../translations/allMessages';
import styles from './styles';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});
function CancelApplication(props) {
  const { onClose, open, cancelApplication, classes } = props;

  return (
    <ADGMModal
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      disableScrollLock
      aria-labelledby='discard-application'
      aria-describedby='confirmation-discard-application'
    >
      <div className={classes.innerModalAccept}>
        <ADGMImage
          name='cross.svg'
          alt='crossicon'
          className={classes.crossIconimg}
          aria-hidden='true'
          onClick={() => onClose()}
        />
        <Typography variant='h6' component='h1' className={classes.Title}>
          <FormattedMessage {...messages.cancel_application} />
        </Typography>
        <Typography variant='h6' component='h2' className={classes.subTitle}>
          <FormattedMessage {...messages.cancel_application_content} />
        </Typography>
        <div className={classes.modalBtnholder}>
          <Button
            className={classes.no}
            onClick={() => onClose()}
            variant='outlined'
            color='secondary'
          >
            <FormattedMessage {...messages.discard} />
          </Button>
          <Button
            onClick={() => {
              onClose();
              cancelApplication();
            }}
            variant='outlined'
            color='primary'
            className={classes.yes}
          >
            <FormattedMessage {...messages.confirm} />
          </Button>
        </div>
      </div>
    </ADGMModal>
  );
}

CancelApplication.propTypes = {
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  cancelApplication: PropTypes.func.isRequired,
};
export default withStyles(styles)(CancelApplication);
